// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.numeric-input-container {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    background: #f9f9f9;
    width: 100px;
}

.numeric-btn {
    background: #007bff;
    color: white;
    border: none;
    font-size: 1.4em;
    width: 32px;
    height: 36px;
    cursor: pointer;
    transition: background 0.2s;
}

.numeric-btn:hover {
    background: #0056b3;
}

.numeric-btn.decrement {
    border-right: 1px solid #ddd;
}

.numeric-btn.increment {
    border-left: 1px solid #ddd;
}

.numeric-input {
    text-align: center;
    width: 50px;
    height: 36px;
    border: none;
    font-size: 1em;
    background: transparent;
    outline: none;
}

/* Для сенсорных экранов */
@media (max-width: 600px) {
    .numeric-input-container {
        width: 90px;
    }
    .numeric-btn {
        width: 28px;
        font-size: 1.2em;
    }
    .numeric-input {
        width: 40px;
        font-size: 0.9em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/components/NumericInput/NumericInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".numeric-input-container {\r\n    display: flex;\r\n    align-items: center;\r\n    border: 1px solid #ddd;\r\n    border-radius: 6px;\r\n    overflow: hidden;\r\n    background: #f9f9f9;\r\n    width: 100px;\r\n}\r\n\r\n.numeric-btn {\r\n    background: #007bff;\r\n    color: white;\r\n    border: none;\r\n    font-size: 1.4em;\r\n    width: 32px;\r\n    height: 36px;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.numeric-btn:hover {\r\n    background: #0056b3;\r\n}\r\n\r\n.numeric-btn.decrement {\r\n    border-right: 1px solid #ddd;\r\n}\r\n\r\n.numeric-btn.increment {\r\n    border-left: 1px solid #ddd;\r\n}\r\n\r\n.numeric-input {\r\n    text-align: center;\r\n    width: 50px;\r\n    height: 36px;\r\n    border: none;\r\n    font-size: 1em;\r\n    background: transparent;\r\n    outline: none;\r\n}\r\n\r\n/* Для сенсорных экранов */\r\n@media (max-width: 600px) {\r\n    .numeric-input-container {\r\n        width: 90px;\r\n    }\r\n    .numeric-btn {\r\n        width: 28px;\r\n        font-size: 1.2em;\r\n    }\r\n    .numeric-input {\r\n        width: 40px;\r\n        font-size: 0.9em;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
